import { render, staticRenderFns } from "./CompanyEditTabInformation.vue?vue&type=template&id=6350b26b"
import script from "./CompanyEditTabInformation.vue?vue&type=script&lang=js"
export * from "./CompanyEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditTabInformation.vue?vue&type=style&index=0&id=6350b26b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports